import { apiClient } from './client';

export interface LoginResponse {
  accessToken: string;
}

// 簡易ログイン（operator）: email + password → JWT。loginID 方式は廃止（社長指示 2026-06-09）。
export async function loginWithPassword(email: string, password: string): Promise<LoginResponse> {
  const res = await apiClient.post<LoginResponse>('/api/auth/login', { email, password });
  return res.data;
}

export interface MeResponse {
  sub: number;
  subjectType: 'user' | 'device';
  tenantId: number;
}

export async function fetchMe(): Promise<MeResponse> {
  const res = await apiClient.get<MeResponse>('/api/auth/me');
  return res.data;
}
